import styled from 'styled-components'

export const Screen = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
`

export const BoundaryBox = styled.div`
  margin: auto;
  padding: 0 20px;
`

export const Error = styled.img`
  max-width: 95%;
`

export const Developer = styled.img`
  max-width: 82%;
`
